<template>
	<div>
		<div class="til">{{name}}</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			name: {
				typeof: String,
				default: ""
			}
		},
		data() {
			return {

			}
		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.til {
		// font-size: 45px;
		font-size: 36px;
		
		font-weight: bold;
		color: #000000;
		margin: 75px auto;
		width: 1200px;
	}

	@media screen and (max-width:1200px) {
		.til {
			width: 100%;
			font-size: 22px;
			padding: 0 30px;
			box-sizing: border-box;
			margin: 10px auto 20px !important;
		}
	}
</style>